@use '@hevoio/hevo-ui-toolkit/styles/mixins' as hevo-toolkit-mixins;
@import '@hevoio/hevo-ui-toolkit/styles/variables';

.refreshAdornment {
  width: 100%;
  padding: $spacer * 0.75 $spacer;
  display: flex;
  cursor: pointer;
}

.errorCaption {
  color: $error !important;
}

.paddedHdMessage {
  font-weight: $font-weight-medium;
  padding: $spacer * 0.75 $spacer;
}

.checkAgainButton {
  padding: $spacer * 0.25 $spacer * 0.5;
  margin-top: -2px;
  background: var(--experiment-btn-bg-color);
  color: var(--text-primary-color);
  border: solid var(--border-width) var(--divider-color);
}

.checkAgainButton:hover {
  background: var(--surface-bg-color) !important;
}

@include  hevo-toolkit-mixins.spinning-animation('.animatedLoadingIcon', 2s);
